/**
 * Сервер объясняет отказ MCP английской фразой исключения
 * (`mcp_access/auth.py: assert_may_use_mcp`) — тем же текстом, что и на
 * самом входе. Показывать её как есть в ru/pl интерфейсе нельзя: переводим
 * известные фразы в ключ i18n, а незнакомую — общей фразой с сырым текстом
 * подробностью.
 */
export type McpBlockedReason =
  | 'notEnabled'
  | 'noRole'
  | 'inactive'
  | 'noLegalEntity'
  | 'superuser'
  | 'unknown';

const REASON_PATTERNS: [RegExp, McpBlockedReason][] = [
  [/not enabled/i, 'notEnabled'],
  [/management role/i, 'noRole'],
  [/active user/i, 'inactive'],
  [/legal entity/i, 'noLegalEntity'],
  [/super ?user/i, 'superuser'],
];

export const mcpBlockedReason = (raw?: string | null): McpBlockedReason => {
  const text = (raw ?? '').trim();
  const hit = REASON_PATTERNS.find(([pattern]) => pattern.test(text));
  return hit ? hit[1] : 'unknown';
};

/** Коды отказа `revokeMcpConnection` (`customErrors.code`). */
export const mcpRevokeErrorKey = (code?: string | null): string =>
  code === 'invalid' || code === 'does_not_exist'
    ? 'pages.mcpAccess.errors.connectionNotFound'
    : 'pages.mcpAccess.revokeFailed';
